import React from 'react';
import { Icons } from '@lon/shared/assets';
import { types } from './duck';
import { IconWrapper } from "./IconWrapper";

const Icon:React.FC<Omit<types.IconProps, 'icons'>> = (props) => <IconWrapper {...props} icons={Icons} />;

export default Icon;
